import React, { Component, Fragment, useState, useEffect, useMemo, } from 'react';
import { GoogleAuthProvider, getAuth, isSignInWithEmailLink, createUserWithEmailAndPassword, sendSignInLinkToEmail, updateProfile, signInWithEmailLink, signInWithRedirect, sendEmailVerification, signInWithEmailAndPassword, } from 'firebase/auth';
import { httpsCallable } from 'firebase/functions';
import { collection, doc, getDoc, query, where, orderBy, limit, addDoc, updateDoc, setDoc, } from 'firebase/firestore';
import { BrowserRouter } from 'react-router-dom';
import { useLocation } from 'react-router';
import { ToastContainer } from 'react-toastify';
import { Button, TabContent, TabPane, Nav, NavItem, NavLink, Form, FormGroup, Label, Input, } from 'reactstrap';
import qs from 'qs';
import classnames from 'classnames';
import logo from '../assets/logo.png';
import { isEmail } from 'validator';
import { toast } from 'react-toastify';
import { pickBy } from 'lodash';
import { differenceInDays } from 'date-fns';
import { createBrowserHistory } from 'history';
import { useToggle, useInterval, } from 'react-use';

import firebase, { functions, db, auth, } from '../firebase';
import UserContext from './contexts/user';
import useFirebaseUser from './hooks/useFirebaseUser';
import useDocumentSubscription from './hooks/useDocumentSubscription';
import useCollectionSubscription from './hooks/useCollectionSubscription';
import EmailVerificationModal from './EmailVerificationModal';
import SubscriptionGate from './SubscriptionGate';
import SignInForm from './forms/SignInForm';
import SignUpForm from './forms/SignUpForm';

export default function Root (props) {
  useEffect(() => {
    const match = window.location.pathname.match(/^\/r\/([^/]+)\/?$/);
    if (match) {
      const code = decodeURIComponent(match[1]);
      window.history.replaceState({}, '', `/signUp?ref=${encodeURIComponent(code)}`);
    }
  }, []);
  const queryParams = qs.parse(window.location.search.slice(1));
  const { firebaseUser, emailVerified, reloadEmailVerified } = useFirebaseUser();
  const [showsLoginForm, toggleLoginForm] = useToggle(false);
  const user = useDocumentSubscription(firebaseUser && doc(collection(db, 'users'), firebaseUser.uid), [firebaseUser]);
  const tenant = useDocumentSubscription(user && doc(collection(db, 'tenants'), user.tenantId), [user]);
  const hasActiveSubscription = tenant && ['active', 'trialing'].includes(tenant.subscriptionStatus);
  const isDemo = tenant && tenant.hasDemo && !tenant.wantsActivation && !hasActiveSubscription;
  const createdAt = user?.createdAt?.toDate?.() || (user?.createdAt && new Date(user.createdAt));
  const isWithinGracePeriod = createdAt && differenceInDays(new Date(), createdAt) < 7;
  const canAccessApp = emailVerified || isWithinGracePeriod;
  useEffect(() => {
    if (firebaseUser != null) {
      toggleLoginForm(false);
    } else if (firebaseUser === null) {
      toggleLoginForm(true);
    }
  }, [firebaseUser]);
  useInterval(() => {
    reloadEmailVerified();
  }, (firebaseUser && !emailVerified) ? 3000 : null);

  const onSubmitSignInForm = async (values) => {
    const { email, password } = values;
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch(e) {
      console.error(e);
      const message = ({
        'auth/invalid-email': 'メールアドレスの形式が正しくありません',
        'auth/user-not-found': 'ユーザーが存在しません',
      })[e.code] || 'ログインに失敗しました';
      toast.error(message);
    }
  };
  const onSubmitSignUpForm = async (values) => {
    const { email, password } = values;
    const { ref } = qs.parse(window.location.search.slice(1));
    try {
      const createUserAndSendEmailVerification = httpsCallable(functions, 'createUserAndSendEmailVerification');
      await createUserAndSendEmailVerification({
        email,
        password,
        ref,
      });
      try {
        await signInWithEmailAndPassword(auth, email, password);
      } catch (e) {
        console.error(e);
      }
      toast.success('ご登録のメールアドレスに確認メールをお送りしました');
    } catch(e) {
      console.error(e);
      const code = e.details?.code || e.code;
      const message = ({
        'auth/invalid-email': 'メールアドレスの形式が正しくありません',
        'auth/weak-password': 'パスワードは最低6文字以上で指定してください',
        'auth/email-already-in-use': 'このメールアドレスは既に使用されています',
      })[code] || '登録に失敗しました';
      toast.error(message);
    }
  };

  return (
    <UserContext.Provider value={user}>
      <div>
        {
          showsLoginForm ? (
            <div className="container py-5">
              <div className="row">
                <div className="col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                  <div className="d-flex justify-content-center mb-5">
                    <img src={logo} alt="Totono" style={{ height: 200 }} />
                  </div>
                  <div className="card">
                    <div className="card-body">
                      {
                        window.location.pathname === '/signUp' ? (
                          <SignUpForm onSubmit={onSubmitSignUpForm} />
                        ) : (
                          <SignInForm onSubmit={onSubmitSignInForm} />
                        )
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            firebaseUser != null && (
              <>
                {hasActiveSubscription || isDemo || user?.admin || user?.isShopifyTester ? (
                  <BrowserRouter>
                    {props.routes({ user, firebaseUser, })}
                  </BrowserRouter>
                ) : tenant ? (
                  <SubscriptionGate />
                ) : null}
                <EmailVerificationModal isOpen={!emailVerified && !isWithinGracePeriod} />
              </>
            )
          )
        }
        <ToastContainer />
      </div>
    </UserContext.Provider>
  );
};
